import { composeContainers } from "@/utils/composeContainers";
import { withActions } from "../../containers/withActions";
import { BoxTypeList } from "./components/BoxTypeList";
import { ContainerProps, ViewProps } from "./types";
import { PopupModal } from "../PopupModal/PopupModal";

export default composeContainers<ViewProps, ContainerProps>({
  containers: [withActions],
  component: ({ ...props }: ViewProps) => (
    <>
      <BoxTypeList {...props} />

      <PopupModal {...props} />
    </>
  ),
});
